var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormControl, OutlinedInput } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import configParams from "../../../assests/config";
import { useForm } from "../../../hooks/UseForm";
import { Button } from "../../Button";
import { ErrorMessage } from "../../ErrorMessage";
import { AuthenticationScreens } from "../data";
import PasswordValidations from "../PasswordValidation";
import * as data from "./data";
import { initializeState } from "./handlers";
import { passwordCheck } from "../PasswordValidation/handlers";
import Styled from "./style";
/**
 * OTP: One Time Password
 * FTP: First Time Password
 * CP: Change Password
 * CPWC: Change Password with Code
 * RP: Reset Passoword form
 */
export const passwordFlowHandles = [
    AuthenticationScreens.OTP,
    AuthenticationScreens.FTP,
    AuthenticationScreens.CPWC,
    AuthenticationScreens.CP,
    AuthenticationScreens.RP,
];
export const PasswordFlow = (props) => {
    const [config, setConfig] = useState(props.config);
    const [showPassword, setShowPassword] = React.useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [initialState, setInitialState] = useState(initializeState(config));
    const { onChange, onSubmit, values } = useForm(formOnSubmit, initialState);
    const { changeConfig, authenticationFlow } = props;
    useEffect(() => {
        setInitialState(initializeState(config));
    }, [config, props.config]);
    useEffect(() => {
        setConfig(props.config);
    }, [props.config]);
    const handleClickShowPassword = useCallback((key) => {
        return () => setShowPassword((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: !prevState[key] })));
    }, []);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    function formOnSubmit() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            setErrorMessage("");
            if (config === AuthenticationScreens.CPWC) {
                try {
                    const cpwcResponse = yield authenticationFlow(Object.assign({}, values));
                    props.changeConfig(cpwcResponse.nextAuth);
                }
                catch (error) {
                    console.error(`config: ${config}:`, error);
                    // setErrorMessage(error.message);
                }
            }
            else if (config === AuthenticationScreens.FTP) {
                try {
                    if (!((_a = passwordCheck(values.newpassword)) === null || _a === void 0 ? void 0 : _a.every((data) => data.valid))) {
                        return setErrorMessage("Password does not conform to policy: Password not long enough");
                    }
                    if ((values === null || values === void 0 ? void 0 : values.newpassword) !== (values === null || values === void 0 ? void 0 : values.newpasswordagain))
                        return setErrorMessage(configParams.errorMessages.PASS_NOT_MATCHED);
                    if (!((_b = [values === null || values === void 0 ? void 0 : values.newpassword.length, values === null || values === void 0 ? void 0 : values.newpasswordagain.length]) === null || _b === void 0 ? void 0 : _b.every((passLength) => passLength <= 50)))
                        return setErrorMessage(configParams.errorMessages.PASSWORD_EXCEEDS);
                    yield authenticationFlow(Object.assign({}, values));
                    // props.changeConfig(AuthenticationScreens.OTP);
                    window.location.reload();
                }
                catch (error) {
                    console.error(`config: ${config}:`, error);
                    setErrorMessage(error.message);
                }
            }
            else {
                try {
                    yield authenticationFlow(Object.assign({}, values));
                }
                catch (error) {
                    console.error(`config: ${config}:`, error);
                    setErrorMessage(error.message);
                }
            }
        });
    }
    const bottomInputBtn = (btn) => () => __awaiter(void 0, void 0, void 0, function* () {
        if (btn.label === configParams.labels.Resend_Code) {
            try {
                yield authenticationFlow({ resend: true });
            }
            catch (error) {
                setErrorMessage(error.message);
            }
        }
    });
    const inputFields = useMemo(() => data.inputFields[props.config || config], [props.config, config]);
    const getDescription = React.useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (props.config === "CPWC" || props.config === "RP") {
            return inputFields.heading.description.replace("email", maskEmail((_a = props === null || props === void 0 ? void 0 : props.userInfo) === null || _a === void 0 ? void 0 : _a.email));
        }
        else if (props.config === "OTP" &&
            ((_f = (_e = (_d = (_c = (_b = props === null || props === void 0 ? void 0 : props.userInfo) === null || _b === void 0 ? void 0 : _b.authenticatedUser) === null || _c === void 0 ? void 0 : _c.authenticatedUser) === null || _d === void 0 ? void 0 : _d.authUserInfo) === null || _e === void 0 ? void 0 : _e.challengeParam) === null || _f === void 0 ? void 0 : _f.CODE_DELIVERY_DESTINATION)) {
            return inputFields.heading.description.replace("registered mobile number", ((_l = (_k = (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.userInfo) === null || _g === void 0 ? void 0 : _g.authenticatedUser) === null || _h === void 0 ? void 0 : _h.authenticatedUser) === null || _j === void 0 ? void 0 : _j.authUserInfo) === null || _k === void 0 ? void 0 : _k.challengeParam) === null || _l === void 0 ? void 0 : _l.CODE_DELIVERY_DESTINATION) ||
                "registered mobile number");
        }
        return inputFields.heading.description;
    }, [config]);
    const maskEmail = (mail) => {
        var _a, _b, _c;
        // console.clear();
        console.log(inputFields, props);
        console.log(mail);
        const split = mail === null || mail === void 0 ? void 0 : mail.split("@");
        if (!(split === null || split === void 0 ? void 0 : split.length) && (split === null || split === void 0 ? void 0 : split.every(Boolean)))
            return "";
        const id = split === null || split === void 0 ? void 0 : split[0].replace((_a = split[0]) === null || _a === void 0 ? void 0 : _a.substring(1, split[0].length), "***");
        const domain = (_b = split === null || split === void 0 ? void 0 : split[1]) === null || _b === void 0 ? void 0 : _b.replace((_c = split[1]) === null || _c === void 0 ? void 0 : _c.substring(1, split === null || split === void 0 ? void 0 : split[1].length), "***");
        return `${id}@${domain}`;
    };
    const navigateToSignIn = () => changeConfig(AuthenticationScreens.login);
    return (React.createElement(Styled, { className: `change-password-flow password-flow-${props.UI}` },
        React.createElement("section", null,
            React.createElement("div", { className: "change-password-flow_heading" },
                React.createElement("h4", null, inputFields.heading.title),
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: getDescription(),
                    } })),
            React.createElement(ErrorMessage, { error: errorMessage }),
            React.createElement("form", { autoComplete: "off", onSubmit: onSubmit },
                React.createElement("div", { className: "change-password-flow_fields" }, inputFields.fields.map((field) => {
                    const { buttonProps } = field, rest = __rest(field, ["buttonProps"]);
                    return (React.createElement(FormControl, null,
                        rest.type === "password" ? (React.createElement(OutlinedInput, Object.assign({ key: field.name }, rest, { type: showPassword[field.name] ? "text" : "password", value: values[field.name], onChange: onChange, endAdornment: React.createElement(InputAdornment, { position: "end" },
                                React.createElement(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword(field.name), onMouseDown: handleMouseDownPassword, edge: "end", sx: {
                                        backgroundColor: "transparent !important",
                                        marginLeft: "-50px",
                                    } }, !showPassword[field.name] ? (React.createElement(VisibilityOff, null)) : (React.createElement(Visibility, null)))) }))) : (React.createElement(OutlinedInput, Object.assign({}, rest, { onChange: onChange, value: values[field.name] }))),
                        buttonProps && (React.createElement("div", { className: "resend-btn" },
                            React.createElement("span", null, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.text),
                            React.createElement(Button, Object.assign({}, buttonProps, { onClick: bottomInputBtn(buttonProps) }))))));
                })),
                React.createElement("div", { className: "change-password-flow_submit" }, inputFields.submit.map((btn) => {
                    const { text } = btn, rest = __rest(btn, ["text"]);
                    return (React.createElement(React.Fragment, null,
                        text && React.createElement("b", null, text),
                        " ",
                        React.createElement(Button, Object.assign({ type: "submit" }, rest))));
                }))),
            values["newpassword"] && props.config !== "OTP" && (React.createElement(PasswordValidations, { value: values["newpassword"] }))),
        React.createElement("div", { className: "forgot-password_go-to-sign" },
            React.createElement("span", null, "Go back to"),
            " ",
            React.createElement(Button, Object.assign({}, {
                label: "Sign In",
                size: "small",
                variant: "text",
                type: "submit",
                className: "sign-in_password",
            }, { onClick: navigateToSignIn })))));
};
